import {
  LOGGED_IN,
  LOG_OUT,
  AUTH_STATUSES,
  AUTH_STATUS_ANONYMOUS,
  AUTH_STATUS_AUTHENTICATED,
  AUTH_STATUS_BOOTSTRAPPING,
  AUTH_STATUS_REAUTHORIZATION_REQUIRED,
  SET_GIM_AUTH_TOKEN,
  SET_GIM_CONNECTION,
  SET_GUEST_TOKEN,
  SET_GUEST_MINT_STATUS,
  GUEST_MINT_STATUS_IDLE,
  GUEST_MINT_STATUS_READY,
  GUEST_MINT_STATUSES,
  SET_ACCESS_TOKEN,
  SET_ACCESS_TOKEN_EXPIRY,
  SET_AUTH_STATUS,
  SET_REAUTHORIZATION_REQUIRED,
  UPDATE_USER,
  USER_INFO,
} from '../types/user';

/**
 *
 */
export const initialState = {
  status: AUTH_STATUS_BOOTSTRAPPING,
  userInfoTestData: {},

  userInfo: /** @type {import('global').UserInfo} */ ({}),
  userRole: '',
  isAdmin: false,
  authToken: '',
  authTokenExpiresAt: 0,
  gimAuthToken: '',
  guestToken: '',
  // Memory only. selectPersistedState already drops the auth slice.
  guestMintStatus: GUEST_MINT_STATUS_IDLE,
  authSessionEpoch: 0,
  isGimConnected: false,
};

/**
 *
 * @returns
 */
const authReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOGGED_IN: {
      const { user, accessToken, role } = payload;
      return {
        ...state,
        status: AUTH_STATUS_AUTHENTICATED,
        userInfo: user,
        authToken: accessToken,
        authTokenExpiresAt: 0,
        authSessionEpoch: (state.authSessionEpoch ?? 0) + 1,
        isAdmin: role?.toLowerCase() === 'admin',
        userRole: role,
        guestToken: '',
      };
    }
    case SET_AUTH_STATUS:
      return AUTH_STATUSES.includes(payload)
        ? {
            ...state,
            status: payload,
          }
        : state;
    case SET_ACCESS_TOKEN:
      return {
        ...state,
        status: AUTH_STATUS_AUTHENTICATED,
        authToken: payload,
        authTokenExpiresAt: 0,
        guestToken: '',
      };
    case SET_ACCESS_TOKEN_EXPIRY:
      return {
        ...state,
        authTokenExpiresAt:
          typeof payload === 'number' && Number.isFinite(payload) ? payload : 0,
      };
    case SET_REAUTHORIZATION_REQUIRED:
      return {
        ...initialState,
        status: AUTH_STATUS_REAUTHORIZATION_REQUIRED,
        authSessionEpoch: (state.authSessionEpoch ?? 0) + 1,
      };
    case UPDATE_USER:
      return {
        ...state,
        userInfo: payload,
        isAdmin: payload?.response?.Role?.toLowerCase() === 'admin',
        userRole: payload?.response?.Role,
      };
    case LOG_OUT:
      return {
        ...initialState,
        status: AUTH_STATUS_ANONYMOUS,
        authSessionEpoch: (state.authSessionEpoch ?? 0) + 1,
      };
    case SET_GIM_AUTH_TOKEN:
      return {
        ...state,
        gimAuthToken: payload,
      };
    case SET_GIM_CONNECTION:
      return {
        ...state,
        isGimConnected: payload,
      };
    case SET_GUEST_MINT_STATUS:
      return GUEST_MINT_STATUSES.includes(payload)
        ? {
            ...state,
            guestMintStatus: payload,
          }
        : state;
    case SET_GUEST_TOKEN:
      return {
        ...state,
        guestToken: payload,
        guestMintStatus: GUEST_MINT_STATUS_READY,
      };
    case USER_INFO:
      return {
        ...state,
        userInfoTestData: payload,
        isAdmin: payload?.Role?.toLowerCase() === 'admin',
      };
    default:
      return state;
  }
};

export default authReducer;
